import createDynamicForm from './fieldcreator';

const contactPage = () => {
    createDynamicForm([
        {
            name: 'your_name',
            field: {
                type: 'input',
                field_type: 'text',
            },
            label: 'Your Name *',
            placeholder: 'Tell us your name',
            class: 'form-field-popup',
            required: true,
        },
        {
            column: [
                {
                    name: 'phone_number',
                    field: {
                        type: 'input',
                        field_type: 'text',
                        init: 'phone',
                    },
                    label: 'Your Phone Number',
                    // placeholder: 'Optionally, your phone',
                    class: 'form-field-popup',
                    id: 'phone-number-area',
                    required: false,
                },
                {
                    name: 'email_address',
                    field: {
                        type: 'input',
                        field_type: 'email',
                    },
                    label: 'Your E-mail *',
                    placeholder: 'A valid e-mail address',
                    class: 'form-field-popup',
                    required: true,
                },
                {
                    name: 'full_phone_number',
                    field: {
                        type: 'input',
                        field_type: 'hidden',
                    },
                },
            ]
        },
        {
            name: 'your_message',
            field: {
                type: 'textarea'
            },
            label: 'Comments / Questions',
            placeholder: '',
            class: 'form-field-popup',
            required: false,
        }
    ], '/safeprocess/51fd62d5098ccfd99e2bf4c3733ade74', '#dynamic-contact-us');
}

export default contactPage;